import { ObjectContainerClientT, MappingClientT, ObjectTypeClientT, ObjectContainerClientDataT, StatusClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useMemo, useState } from 'react';
import BrandingService from '../../../../services/branding.service';
import { AppContext } from '../../../../state/app.state';
import { formatValue } from '../../../../utils/object.helper';
import { objectTypePropertySorting, objectTypeProperyFiltering } from '../../../../utils/objectType.helper';
import { calculateStyle, calculateTipForegroundStyle, calculateTipStyle, getPolygonMeasurements, measureImage, PolygonMeasurementsT } from '../mapping.helper';

import './MappingFacts.scss';

type Props = {
    objectId?: number;
    previewObjectMapping?: MappingClientT;
    previewObjectType?: ObjectTypeClientT;
    previewObject?: ObjectContainerClientT;
}


const MappingFacts: React.FC<Props> = ({ previewObject, previewObjectMapping, previewObjectType }): ReactElement => {
    const { presentationState, state } = useContext(AppContext);

    const [imageDimensions] = useState(measureImage());

    const polygonMeasurements = useMemo((): PolygonMeasurementsT => {
        return getPolygonMeasurements(previewObjectMapping);
    }, [previewObjectMapping]);

    const status = useMemo((): StatusClientT | undefined => {
        return state?.project?.statuses.find(s => s.id === previewObject?.statusId);
    }, [previewObject?.statusId, state?.project?.statuses]);

    const filterPreviewObject = (d: ObjectContainerClientDataT) => d.value !== null && (previewObjectType ? previewObjectType?.properties.find(p => p.id === d.propId) : true);

    return useObserver(() => (
        <div style={{ ...calculateStyle(polygonMeasurements, imageDimensions, previewObjectMapping, presentationState?.zoomScale), transform: `scale(${(1 / (presentationState?.zoomScale || 1))})` }} className={'bv-mapping-facts-label'}>
            <>
                <div className="bv-mapping-facts-label-tip-foreground" style={calculateTipForegroundStyle(polygonMeasurements, previewObjectMapping)}>
                </div>
                <div className="bv-mapping-facts-label-content">
                    {status && <div className={`bv-mapping-facts-label-content-row bv-mapping-facts-label-content-row--status bv-${status?.type}`}>
                        <span className="bv-mapping-facts-label-content-row-name  bv-mapping-facts-label-content-row-name--status">{status?.singular} </span>
                        <span className="bv-mapping-facts-label-content-row-value  bv-mapping-facts-label-content-row-value--status"></span>
                    </div>}
                    <div className="bv-mapping-facts-label-content-text">
                        {<div className={'bv-mapping-facts-label-content-title'} >
                            {previewObjectType && previewObjectType.name} {previewObject && previewObject.name}
                        </div>}
                        {previewObject && previewObject.data.slice().sort(objectTypePropertySorting)
                            .filter(filterPreviewObject)
                            .filter(objectTypeProperyFiltering)
                            .map((d, i) => {
                                const currentType = previewObjectType?.properties.find(p => p.id === d.propId);

                                return <div className="bv-mapping-facts-label-content-row" key={i}>
                                    <span className="bv-mapping-facts-label-content-row-name">{d.name}:</span>
                                    <span className="bv-mapping-facts-label-content-row-value">{formatValue(d, currentType?.type)} {currentType?.type === 'floor' ? (d.value !== 0 ? currentType?.ending : '') : currentType?.ending} </span>
                                </div>;
                            })}
                    </div>
                </div>
            </>
        </div>
    ));
};

export default MappingFacts;